var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
import * as pc from "playcanvas";
var timeBetweenUpdates = 0.2; // 200ms — matches Node3D position throttling
/**
 * Tracks where a world point lands on screen, for anchoring a DOM overlay to
 * something in the scene. Re-projected every frame (throttled to match the
 * Node3D pattern), so it follows the camera; only re-renders when the screen
 * position actually changed. `null` until the first projection.
 */
export var useWorldScreenPosition = function (app, x, y, z) {
    var _a = __read(useState(null), 2), position = _a[0], setPosition = _a[1];
    useEffect(function () {
        var cameraEntity = app.root.findByName("Camera");
        var camera = cameraEntity === null || cameraEntity === void 0 ? void 0 : cameraEntity.camera;
        var timeSinceLastUpdate = 0;
        var worldPosition = new pc.Vec3(x, y, z);
        var updatePosition = function (dt) {
            timeSinceLastUpdate += dt;
            if (timeSinceLastUpdate < timeBetweenUpdates)
                return;
            timeSinceLastUpdate = 0;
            if (!camera)
                return;
            var screen = camera.worldToScreen(worldPosition);
            setPosition(function (prev) {
                return (prev === null || prev === void 0 ? void 0 : prev.x) === screen.x && (prev === null || prev === void 0 ? void 0 : prev.y) === screen.y
                    ? prev
                    : { x: screen.x, y: screen.y };
            });
        };
        app.on("update", updatePosition);
        return function () {
            app.off("update", updatePosition);
        };
    }, [app, x, y, z]);
    return position;
};
